import React from 'react';
import { Link } from 'react-router-dom';

import ThirdParties from './ThirdParties';
import withRouter from '../../../util/WithRouter';

import './ThirdParty.css';

class ThirdPartyList extends React.Component {

  constructor(props) {
    super(props);
    this.state = { active: 'lead' };
  }

  onTabClick = active => this.setState({ ...this.state, active });

  render() {
    const path = this.props.match.path;
    const options = [
      { label: 'Lead Portal', value: 'lead' },
      { label: 'AI Integration', value: 'aiIntegration' },
      { label: 'Cloud Telephony', value: 'cloud' },
      { label: 'Whats App', value: 'whatsapp' },
      { label: 'Webhook', value: 'webhook' },
      { label: 'Social', value: 'social' },
      { label: 'Payment Gateway', value: 'paymentGateway' },
      { label: 'Email', value: 'email' },
      { label: 'Accounts', value: 'accounts' },
      { label: 'SMS', value: 'sms' },
    ];
    return (
      <section className="cloud-telephony integrationsec pb-5">
        <div className="container-fluid">
          <div className="col-md-12">
            <div className="content-box">
              <nav className="project-tab">
                <div className="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                  {options.map((opt, i) =>
                    <span id="nav-home-tab" data-toggle="tab" role="tab" aria-controls="nav-home"
                      className={`alert alert-dark nav-item nav-link ${this.state.active === opt.value ? 'active' : ''}`}
                      aria-selected="true" key={`tab_${i}`} onClick={() => this.onTabClick(opt.value)}>
                      {opt.label}
                    </span>
                  )
                  }
                </div>
              </nav>
            </div>
          </div>

          <div className="row pt-4">
            {
              ThirdParties[this.state.active].filter(item => item.status === 1).map(party =>
                <div key={`third-party-${party.id}`} className="col-md-3">
                  <div className="icon-box s2 box-hover-gradient">
                    <div className="icon-main"> <img src={party.img} alt="img-cloud"  /></div>
                    <div className="content-box">
                      <h5 className="box-title">{party.name}</h5>
                      <p><button className="configure-btn">
                        <Link to={`${path}/${party.link}`}>Configure</Link>
                      </button></p>
                    </div>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </section>
    );
  }
}
export default withRouter(ThirdPartyList);
